import { create } from 'zustand';
const byTimestampDesc = (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
export const useNotificationTrayStore = create((set) => ({
    items: [],
    addNotifications: (items) => set((state) => {
        if (!items.length)
            return state;
        const next = [...state.items];
        for (const item of items) {
            const idx = next.findIndex((entry) => entry.id === item.id);
            if (idx >= 0) {
                next[idx] = { ...next[idx], ...item };
            }
            else {
                next.push(item);
            }
        }
        next.sort(byTimestampDesc);
        return { items: next };
    }),
    markRead: (id) => set((state) => ({
        items: state.items.map((item) => (item.id === id ? { ...item, read: true } : item)),
    })),
    markAllRead: () => set((state) => ({
        items: state.items.map((item) => ({ ...item, read: true })),
    })),
    removeNotification: (id) => set((state) => ({ items: state.items.filter((item) => item.id !== id) })),
    clear: () => set({ items: [] }),
}));
//# sourceMappingURL=useNotificationTrayStore.js.map